import {
  HELP_PAGE_REQUEST,
  HELP_PAGE_SUCCESS,
  HELP_PAGE_FAIL,
  FETCH_BYID_SUCCESS,
  HELP_PAGE_SEARCH_SUCCESS,
} from "../actions/types";

const initialState = {
  allHelpPageContent: [],
  isLoading: false,
  error: null,
  content: [],
  searchedResult: [],
};

const HelpingPageReducer = (state = initialState, action) => {
  switch (action.type) {
    case HELP_PAGE_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case HELP_PAGE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        allHelpPageContent: action.payload.allHelpPageContent,
      };

    case HELP_PAGE_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    case FETCH_BYID_SUCCESS:
      return {
        ...state,
        content: action.payload,
      };
    case HELP_PAGE_SEARCH_SUCCESS:
      return {
        ...state,
        searchedResult: action.payload.searchedData,
      };
    default:
      return state;
  }
};

export default HelpingPageReducer;
